import React, { Component } from 'react';

import IndexNoticeModal from "../component/IndexNoticeModal";

import * as apiUtil from "../../../util/apiUtil";
import * as dateUtil from "../../../util/dateUtil";
import BiztingLanding from "../container/BiztingLanding";
import PromotionModal from "../component/modal/PromotionModal";

const LINK_NAVER_DA = "https://docs.google.com/forms/d/e/1FAIpQLSdcAdaBzAywgQiqdqFieCBmV6T0PNBXVblNU-dAwTsOOGLeoQ/viewform?usp=pp_url&entry.2008861792=%EB%84%A4%EC%9D%B4%EB%B2%84+DA";
const LINK_NAVER_SA = "https://docs.google.com/forms/d/e/1FAIpQLSdcAdaBzAywgQiqdqFieCBmV6T0PNBXVblNU-dAwTsOOGLeoQ/viewform?usp=pp_url&entry.2008861792=%EA%B2%80%EC%83%89%EA%B4%91%EA%B3%A0";
const LINK_GENERAL = "https://docs.google.com/forms/d/e/1FAIpQLSdcAdaBzAywgQiqdqFieCBmV6T0PNBXVblNU-dAwTsOOGLeoQ/viewform?usp=pp_url&entry.2008861792=%EC%9D%BC%EB%B0%98";
const PROMOTION_ITEMS = [
    {
        imageSrc: "/assets/img/promotion/iosRCS_pop_img.png",
        alt: "아이폰 RCS 안내",
    },
    {
        imageSrc: "/assets/img/promotion/bizting_26_3_promotion.png",
        linkMode: "static",
        defaultUrl: "/cash/charge",
        openInNewTab: false,
    },
    {
        imageSrc: "/assets/img/promotion/moment_event_v1.0.png",
        linkMode: "static",
        defaultUrl: "/moment/index",
        openInNewTab: false,
    },
];


class IntroContainer extends Component {
    constructor(props) {
        super(props);

        this.ajaxLogAdSrc = this.ajaxLogAdSrc.bind(this);
        this.ajaxCountAdSrc = this.ajaxCountAdSrc.bind(this);
        this.ajaxRecentNoticeList = this.ajaxRecentNoticeList.bind(this);
        this.saveAdSrcToStorage = this.saveAdSrcToStorage.bind(this);

        this.handleNoticeModal = this.handleNoticeModal.bind(this);
        this.setValue = this.setValue.bind(this);
        this.setPromotionLink = this.setPromotionLink.bind(this);

        this.state = {
            noticeModalOpen: false,
            noticeModalReady: false,
            noShowToday: false,
            promotionLink: LINK_GENERAL,
            recentNotices: [],
        }
    }

    componentDidMount() {
        this.ajaxCountAdSrc();
        this.setPromotionLink();
        // this.ajaxLogAdSrc();

        const noShowTodayLocalStorage = window.localStorage.getItem("INDEX_NOTICE_MODAL_HIDE_DATE");
        if (noShowTodayLocalStorage) {
            const obj = JSON.parse(noShowTodayLocalStorage)
            const now = dateUtil.dateToStr(new Date());
            if (obj.validUntil >= now) {
                this.setState({
                    noticeModalOpen: false,
                    noticeModalReady: true,
                });
                return;
            } else {
                window.localStorage.removeItem("INDEX_NOTICE_MODAL_HIDE_DATE");
            }
        }

        this.ajaxRecentNoticeList();
    }

    async ajaxCountAdSrc() {
        const adSrc = sessionStorage.getItem('adSrc');
        const sessionId = sessionStorage.getItem('sessionId');

        apiUtil.asyncRequest({
            url: `/api/common/adpath/count`,
            method: apiUtil.requestMethod.POST,
            data: {
                adSrc,
                type: 'VISIT',
                sessionId,
            }
        });
    }

    ajaxRecentNoticeList() {
        apiUtil.asyncRequest({
            url: "/api/notice/recent",
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                const recentNotices = Array.isArray(result) ? result : [];
                this.setState({
                    recentNotices,
                    noticeModalOpen: recentNotices.length > 0,
                    noticeModalReady: true,
                });
            },
            error: () => {
                this.setState({
                    recentNotices: [],
                    noticeModalOpen: false,
                    noticeModalReady: true,
                });
            },
        });
    }


    async ajaxLogAdSrc() {
        const { adSrc } = this.props;
        if (adSrc) {
            this.saveAdSrcToStorage();

            const ip = await apiUtil.getClientIp()
            apiUtil.asyncRequest({
                url: `/api/common/adpath`,
                method: apiUtil.requestMethod.POST,
                header: {
                    'x-forwarded-for': ip
                },
                data: {
                    adSrc: adSrc,
                },
                success: (result) => {
                }
            })
        }
    }

    saveAdSrcToStorage() {
        const { adSrc } = this.props;
        window.sessionStorage.setItem('adSrc', adSrc);
    }

    setPromotionLink() {
        try {
            const adSrc = sessionStorage.getItem('adSrc');
            if (adSrc) {
                // 공백을 +로 치환 (URL 디코딩 이슈 대응)
                let replacedAdSrc = adSrc.replace(/ /g, '+');

                // Base64 Decode (UTF-8 지원)
                // Java: new String(Base64.getEncoder().encode(str.getBytes(StandardCharsets.UTF_8)))
                // JS 대응: atob 후 UTF-8 바이트 시퀀스를 문자열로 변환
                const decodedString = decodeURIComponent(atob(replacedAdSrc).split('').map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

                let decryptedAdSrc = JSON.parse(decodedString);

                if (decryptedAdSrc && decryptedAdSrc.adPath) {
                    if (decryptedAdSrc.adPath === 'NAVER_DA') {
                        this.setState({ promotionLink: LINK_NAVER_DA });
                        return;
                    } else if (decryptedAdSrc.adPath === 'NAVER_SA') {
                        this.setState({ promotionLink: LINK_NAVER_SA });
                        return;
                    }
                }
            }
        } catch (e) {
            console.error("Failed to parse adSrc", e);
        }
        // Default is already set to LINK_GENERAL
    }

    handleNoticeModal() {
        const { noticeModalOpen, noShowToday } = this.state;

        if (noticeModalOpen && noShowToday) {
            // 모달이 열려 있고, 오늘 다시 보지 않기에 체크 되어 있을 때
            const obj = {
                value: "Y",
                validUntil: dateUtil.dateToStr(new Date()),
            }
            window.localStorage.setItem("INDEX_NOTICE_MODAL_HIDE_DATE", JSON.stringify(obj));
        }

        this.setState({ noticeModalOpen: !noticeModalOpen });
    }

    setValue(id, value) {
        const { noShowToday } = this.state;

        switch (id) {
            case "noShowToday":
                this.setState({ noShowToday: !noShowToday });
                break;
        }
    }

    render() {
        const { noticeModalOpen, noShowToday, promotionLink, recentNotices } = this.state;
        const { noticeModalReady } = this.state;
        const { handleNoticeModal, setValue } = this;

        return (
            <>
                {noticeModalReady && !noticeModalOpen && <PromotionModal items={PROMOTION_ITEMS} />}
                <BiztingLanding
                    promotionLink={promotionLink}
                />
                {/*<div className="container-xxl pb-4">*/}
                {/*<h2 className="fs-4">서비스 소개</h2>*/}
                {/*<div className="card">*/}
                {/*    <div className="card-body d-flex align-items-center justify-content-center">*/}
                {/*        <img src="/assets/img/intropage_img.png" alt="이미지 없음" style={{*/}
                {/*            width: '100%',*/}
                {/*            height: 'auto',*/}
                {/*        }}/>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*</div>*/}
                <IndexNoticeModal
                    open={noticeModalOpen}
                    handleClose={handleNoticeModal}
                    noShowToday={noShowToday}
                    setValue={setValue}
                    notices={recentNotices}
                />
            </>
        )
    }

}

export default IntroContainer;
